
























import { computed, defineComponent, ref } from "@vue/composition-api";
import { UserPublicData } from "@scrile/api-provider/dist/projects/scrileConnect/UserPublicDataProvider";
import useAuthorisedOnly from "@/hooks/useAuthorisedOnly";
import emitter from "@/lib/emitter";
import { getProfileUrl } from "@/lib/urlHelpers";
import config from "@/config";
import { ViewStoriesSettings } from "@/types";
import { EVENTS } from "@/const";
import ChooseContentConfirm from "@/components/ChooseContentConfirm";
import InfiniteScroll from "@/components/InfiniteScroll";
import CreatorsListItem from "../CreatorsListItem";

export default defineComponent({
  name: "CreatorsList",
  components: { ChooseContentConfirm, InfiniteScroll, CreatorsListItem },
  props: {
    creatorsList: { type: Array as () => UserPublicData[], required: true },
    enableScroll: { type: Boolean, required: true },
  },
  setup(_, { root }) {
    const storiesEnabled = computed(() => config.featureStories);
    const selectedCreator = ref<UserPublicData | null>(null);

    const handleShowStories = useAuthorisedOnly(() => {
      if (!(storiesEnabled.value && selectedCreator.value)) return;
      emitter.emit<ViewStoriesSettings>(EVENTS.STORIES_SHOW, {
        storyPublishers: [{ userId: selectedCreator.value.id, user: selectedCreator.value }],
        currentStoryId: selectedCreator.value.firstNotViewedStoryId || undefined,
      });
      selectedCreator.value = null;
    });
    const handleGoToProfile = () => {
      if (!selectedCreator.value) return;
      root.$router.push(getProfileUrl(selectedCreator.value));
    };

    return { selectedCreator, storiesEnabled, handleShowStories, handleGoToProfile };
  },
});
